import { configureStore } from "@reduxjs/toolkit"
import cartReducer from "./slices/cartSlice"
import wishlistReducer from "./slices/wishlistSlice"
import authReducer from "./slices/authSlice"

export const store = configureStore({
  reducer: {
    cart: cartReducer,
    wishlist: wishlistReducer,
    auth: authReducer,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
const RootState = store.getState
export const AppDispatch = store.dispatch
